/*
  Delivery promise for the product page delivery card (snippets/iwa-delivery-card.liquid) and
  the arrival line under cart rows (S4: snippets/cart-item.liquid, data from
  snippets/iwa-delivery-cart-config.liquid).
  Port of ~/claude/vscode/iwa-delivery-promise/reference/promise.mjs; the rules and the
  numbers are in that folder's README.md.

  Config comes from the shop metafield iwa.delivery_config (printed by the snippets). Without it
  the arrival line stays hidden, except on a non-live theme with ?iwa_promise_test=1, which uses
  the proposed v0 table below (lanes-v0.json, 2026-10-19; not confirmed by the owner; card only).
*/
(function () {
  'use strict';
  // The card and the cart config can both load this file: run once.
  if (window.IWADelivery) return;

  var V0 = {
    version: 'v0-2026-10-19 (test only)',
    origins: {
      FF: { tz: 'America/New_York', cutoffHour: 12, workdays: [1, 2, 3, 4, 5], holidays: 'US', dispatch: [0, 1] },
      ANK: { tz: 'Europe/Istanbul', cutoffHour: 8, workdays: [1, 2, 3, 4, 5], holidays: 'TR', dispatch: [1, 2] }
    },
    holidays: {
      TR: ['2026-10-29', '2027-01-01', '2027-03-09', '2027-03-10', '2027-03-11', '2027-04-23', '2027-05-01',
        '2027-05-16', '2027-05-17', '2027-05-18', '2027-05-19', '2027-07-15', '2027-08-30', '2027-10-29'],
      US: ['2026-11-26', '2026-12-25', '2027-01-01', '2027-05-31', '2027-07-05', '2027-09-06', '2027-11-25', '2027-12-24']
    },
    destHolidays: { US: 'US' },
    productionSpread: 2,
    defaultProductionDays: 3,
    lanes: {
      'FF|US': [2, 4],
      'ANK|US': [3, 6], 'ANK|CA': [3, 6], 'ANK|GB': [2, 3], 'ANK|DE': [2, 6], 'ANK|EU': [2, 5],
      'ANK|AU': [4, 7], 'ANK|GULF': [3, 6], 'ANK|OTHER': [4, 8]
    },
    groups: {
      EU: ['AT', 'BE', 'DK', 'FR', 'GR', 'IE', 'IT', 'LI', 'LU', 'MC', 'NL', 'PT', 'ES', 'SE', 'FI', 'CH', 'NO', 'SK', 'SI', 'CZ', 'EE', 'LV', 'LT', 'HU', 'RO', 'CY'],
      GULF: ['SA', 'AE', 'KW', 'QA', 'BH', 'OM', 'SG']
    },
    own: ['US', 'CA', 'GB', 'AU', 'DE'],
    noPromise: ['TR', 'CN', 'IN', 'PK'],
    peakBufferDays: 0
  };

  // ---------------------------------------------------------------- calendar helpers
  // Dates are 'YYYY-MM-DD' strings in the calendar of the place that owns them.
  function addDays(iso, n) {
    return new Date(Date.parse(iso + 'T00:00:00Z') + n * 864e5).toISOString().slice(0, 10);
  }
  function weekday(iso) {
    return new Date(iso + 'T00:00:00Z').getUTCDay();
  }
  function isWork(iso, cal) {
    return cal.workdays.indexOf(weekday(iso)) !== -1 && cal.holidays.indexOf(iso) === -1;
  }
  function nextWork(iso, cal) {
    do { iso = addDays(iso, 1); } while (!isWork(iso, cal));
    return iso;
  }
  function addWork(iso, n, cal) {
    for (; n > 0; n--) iso = nextWork(iso, cal);
    return iso;
  }
  function localDateHour(now, tz) {
    var p = {};
    new Intl.DateTimeFormat('en-CA', {
      timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23'
    }).formatToParts(now).forEach(function (x) { p[x.type] = x.value; });
    return { date: p.year + '-' + p.month + '-' + p.day, hour: Number(p.hour) };
  }
  function holidayList(cfg, ref) {
    if (Array.isArray(ref)) return ref;
    return (cfg.holidays && cfg.holidays[ref]) || [];
  }
  function originCal(cfg, key) {
    var o = cfg.origins[key];
    return { tz: o.tz, cutoffHour: o.cutoffHour, workdays: o.workdays, holidays: holidayList(cfg, o.holidays), dispatch: o.dispatch };
  }
  function destCal(cfg, cc) {
    var ref = cfg.destHolidays && cfg.destHolidays[cc];
    return { workdays: [1, 2, 3, 4, 5], holidays: ref ? holidayList(cfg, ref) : [] };
  }
  // Order day: today at the origin, or the next workday if today is off or past the cutoff.
  function orderDay(now, o) {
    var l = localDateHour(now, o.tz);
    return isWork(l.date, o) && l.hour < o.cutoffHour ? l.date : nextWork(l.date, o);
  }

  // ---------------------------------------------------------------- the algorithm (README §3)
  function countryGroup(cfg, cc) {
    if (!cc || cfg.noPromise.indexOf(cc) !== -1) return null;
    if (cfg.own.indexOf(cc) !== -1) return cc;
    for (var g in cfg.groups) {
      if (cfg.groups[g].indexOf(cc) !== -1) return g;
    }
    return 'OTHER';
  }

  // lines: [{ variantId, qty, ff, ank, p, ship }]
  function promise(cfg, lines, cc, now) {
    var ship = lines.filter(function (l) { return l.ship !== false; });
    var group = countryGroup(cfg, cc);
    if (!ship.length || !group) return null;

    var need = {};
    ship.forEach(function (l) { need[l.variantId] = (need[l.variantId] || 0) + l.qty; });

    // US orders ship from Fairfield only if Fairfield has every line; otherwise all from Ankara.
    var originKey = cc === 'US' && ship.every(function (l) { return (l.ff || 0) >= need[l.variantId]; }) ? 'FF' : 'ANK';
    var transit = cfg.lanes[originKey + '|' + group];
    if (!transit) return null;
    var o = originCal(cfg, originKey);

    var slowest = null;
    var prepMin = 0;
    var prepMax = 0;
    ship.forEach(function (l) {
      var range;
      var mode = 'stock';
      if (originKey === 'FF' || (!l.prep && (l.ank || 0) >= need[l.variantId])) {
        range = o.dispatch;
      } else if (l.prep) {
        // a category with a fixed Ankara prep range (prayer rugs: [1, 1]), stock or not
        range = l.prep;
      } else {
        var P = l.p != null ? l.p : cfg.defaultProductionDays;
        range = [Math.max(o.dispatch[0], P - cfg.productionSpread), P];
        mode = 'production';
      }
      prepMin = Math.max(prepMin, range[0]);
      if (!slowest || range[1] > prepMax) slowest = { variantId: l.variantId, mode: mode, range: range };
      prepMax = Math.max(prepMax, range[1]);
    });

    var d0 = orderDay(now || new Date(), o);
    var dest = destCal(cfg, cc);
    var shipBy = addWork(d0, prepMax, o);
    return {
      origin: originKey,
      orderDay: d0,
      shipBy: shipBy,
      from: addWork(addWork(d0, prepMin, o), transit[0], dest),
      to: addWork(shipBy, transit[1] + (cfg.peakBufferDays || 0), dest),
      slowest: slowest,
      version: cfg.version || ''
    };
  }

  // ---------------------------------------------------------------- the card
  // English: "Thu, Oct 22" in the US market, "Thu 22 Oct" elsewhere; ar keeps Latin digits.
  function intlLocale(locale, market) {
    if (locale === 'en') return market === 'us' ? 'en-US' : 'en-GB';
    if (locale === 'ar') return 'ar-u-nu-latn';
    return locale || 'en-GB';
  }
  function fmt(iso, locale, market) {
    return new Intl.DateTimeFormat(intlLocale(locale, market), {
      weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC'
    }).format(new Date(iso + 'T12:00:00Z'));
  }
  // ?iwa_promise_test=1 (dates from the v0 table) or =write (also writes the cart attribute); never on the live theme.
  function testParam() {
    try {
      var role = window.Shopify && window.Shopify.theme && window.Shopify.theme.role;
      return role !== 'main' ? new URLSearchParams(window.location.search).get('iwa_promise_test') : null;
    } catch (e) {
      return null;
    }
  }
  function testMode() {
    var t = testParam();
    return t === '1' || t === 'write';
  }
  function promiseValue(p) {
    return p ? [p.from + '..' + p.to, p.origin, p.slowest.mode, 'shipBy=' + p.shipBy, p.version].join('|') : '';
  }

  function update(card, variantId) {
    var data = card._iwaData;
    card._iwaVariant = variantId;
    var v = variantId != null && data.variants[String(variantId)];
    if (!v || !v.available || v.ship === false) {
      card.hidden = true;
      return;
    }
    card.hidden = false;

    var arrives = card.querySelector('[data-iwa-delivery-arrives]');
    var from = card.querySelector('[data-iwa-delivery-from]');
    var p = data.cfg && promise(data.cfg, [{
      variantId: String(variantId), qty: 1, ff: v.ff, ank: Math.max(0, v.ank || 0), p: v.p, prep: v.prep, ship: v.ship
    }], data.country);

    // Ramadan products in Sha'ban (countdown period up to the Ramadan order-by day): the
    // first line is the order-by sentence of the collection bar (assets/iwa-orderby.js).
    var ob = null;
    if (p && data.orderby && window.IWAOrderBy) {
      var r = window.IWAOrderBy.compute(Object.assign({ country: data.country, config: data.config }, data.orderby));
      if (r && r.phase === 'ramadan' && r.emphasis) ob = r;
    }
    if (arrives) {
      var country = arrives.querySelector('.iwa-delivery__country');
      if (ob) {
        arrives.querySelector('[data-iwa-delivery-range]').textContent = arrives.getAttribute('data-orderby-template')
          .replace('__START__', window.IWAOrderBy.format(data.orderby.ramadanStart, card, true))
          .replace('__DATE__', window.IWAOrderBy.format(ob.ramadan, card, true));
        if (country) country.hidden = true;
        arrives.hidden = false;
        arrives.classList.remove('is-pending');
      } else if (p) {
        arrives.querySelector('[data-iwa-delivery-range]').textContent = arrives.getAttribute('data-template')
          .replace('__FROM__', fmt(p.from, card.dataset.locale, card.dataset.market))
          .replace('__TO__', fmt(p.to, card.dataset.locale, card.dataset.market));
        if (country) country.hidden = false;
        arrives.hidden = false;
        arrives.classList.remove('is-pending');
      } else {
        arrives.hidden = true;
      }
    }
    card.dataset.orderby = ob ? 'ramadan:' + ob.ramadan : '';
    if (from) {
      if (p) {
        var key = p.origin === 'FF' ? 'ff' : (p.slowest.mode === 'production' ? 'mto' : 'ank');
        from.textContent = from.getAttribute('data-' + key).replace('__DATE__', fmt(p.shipBy, card.dataset.locale, card.dataset.market));
        from.hidden = false;
        from.classList.remove('is-pending');
      } else {
        from.hidden = true;
      }
    }

    // A row whose lines are all hidden goes; so does the card when no row is left.
    var row = card.querySelector('[data-iwa-delivery-ship-row]');
    if (row) {
      row.hidden = !Array.prototype.some.call(row.querySelectorAll('p'), function (el) { return !el.hidden; });
    }
    card.hidden = !Array.prototype.some.call(card.querySelectorAll('.iwa-delivery__row'), function (el) { return !el.hidden; });

    card.dataset.promise = promiseValue(p);
  }

  function init(card) {
    if (card._iwaData) return;
    var raw = card.querySelector('[data-iwa-delivery-data]');
    var data;
    try {
      data = JSON.parse(raw.textContent);
    } catch (e) {
      card.hidden = true;
      return;
    }
    data.cfg = data.config || (testMode() ? V0 : null);
    card._iwaData = data;
    update(card, data.current);
  }

  function initAll() {
    document.querySelectorAll('[data-iwa-delivery]').forEach(init);
  }

  // ---------------------------------------------------------------- cart attribute _delivery_promise
  // The whole cart's promise, stored on the order for the promise-vs-delivery report. Written only
  // with a real config (shop metafield), or on a non-live theme with ?iwa_promise_test=write.
  var syncTimer = null;
  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  function syncCartPromise() {
    var card = document.querySelector('[data-iwa-delivery]');
    var data = card && card._iwaData;
    if (!data || !data.cfg || !(data.config || testParam() === 'write')) return null;
    return Promise.all([
      fetch(root() + '?sections=iwa-delivery-cart-data', { credentials: 'same-origin' }).then(function (r) { return r.json(); }),
      fetch(root() + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
    ]).then(function (res) {
      var html = res[0] && res[0]['iwa-delivery-cart-data'];
      var cart = res[1];
      if (!html || !cart || !cart.item_count) return null;
      var el = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-iwa-delivery-cart]');
      var d = JSON.parse(el.textContent);
      var lines = d.lines.map(function (l) {
        return { variantId: l.variantId, qty: l.qty, ff: l.v.ff, ank: Math.max(0, l.v.ank || 0), p: l.v.p, prep: l.v.prep, ship: l.ship };
      });
      var value = promiseValue(promise(data.cfg, lines, d.country));
      if ((cart.attributes || {})._delivery_promise === value) return value;
      return fetch(root() + 'cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { _delivery_promise: value } })
      }).then(function () { return value; });
    }).catch(function () { return null; });
  }
  function scheduleSync() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(syncCartPromise, 400);
  }
  document.addEventListener('ajaxProduct:added', scheduleSync);
  document.addEventListener('cart:updated', scheduleSync);

  // ---------------------------------------------------------------- cart rows (S4)
  // Every row that ships ([data-iwa-cart-arrives]) shows the whole order's range: one parcel, so
  // the slowest line decides (README §1 "Sepet"). The drawer and the cart page are two lists
  // ([data-products]) of the same cart, each computed on its own.
  var CART_LISTS = '#CartDrawerForm [data-products], #CartPageForm [data-products]';
  var cartTimer = null;
  function readJSON(el) {
    try {
      return el ? JSON.parse(el.textContent) : null;
    } catch (e) {
      return null;
    }
  }
  function fillCart() {
    var conf = readJSON(document.querySelector('[data-iwa-delivery-cart-config]'));
    if (!conf || !conf.config) return;
    document.querySelectorAll(CART_LISTS).forEach(function (list) {
      var hooks = list.querySelectorAll('[data-iwa-cart-arrives]');
      if (!hooks.length) return;
      var lines = [];
      hooks.forEach(function (h) {
        var v = readJSON(h.querySelector('script'));
        if (v) {
          lines.push({
            variantId: h.dataset.variantId, qty: Number(h.dataset.qty) || 1, ff: v.ff, ank: Math.max(0, v.ank || 0), p: v.p, prep: v.prep, ship: v.ship
          });
        }
      });
      // A row without its data would leave out a line that may be the slowest: no date then.
      var p = lines.length === hooks.length ? promise(conf.config, lines, conf.country) : null;
      var text = p ? conf.arrives
        .replace('__FROM__', fmt(p.from, conf.locale, conf.market))
        .replace('__TO__', fmt(p.to, conf.locale, conf.market)) : '';
      hooks.forEach(function (h) {
        var t = h.querySelector('[data-iwa-cart-arrives-text]');
        if (t && t.textContent !== text) t.textContent = text;
        h.hidden = !text;
      });
    });
  }
  function scheduleCart() {
    clearTimeout(cartTimer);
    cartTimer = setTimeout(fillCart, 0);
  }
  // The drawer and the cart page replace their rows (the children of [data-products]) after
  // every change; only that level is watched, so filling the text does not trigger it again.
  function watchCart() {
    if (!window.MutationObserver) return;
    var mo = new MutationObserver(scheduleCart);
    document.querySelectorAll(CART_LISTS).forEach(function (list) {
      mo.observe(list, { childList: true });
    });
  }
  document.addEventListener('ajaxProduct:added', scheduleCart);
  document.addEventListener('cart:updated', scheduleCart);

  document.addEventListener('variant:change', function (e) {
    var variant = e.detail && (e.detail.variant || e.detail);
    document.querySelectorAll('[data-iwa-delivery]').forEach(function (card) {
      if (!card._iwaData) init(card);
      if (!card._iwaData) return;
      if (!variant || !variant.id) {
        card.hidden = true;
        return;
      }
      if (card._iwaData.variants[String(variant.id)]) update(card, variant.id);
    });
  });

  window.IWADelivery = {
    syncCart: syncCartPromise,
    fillCart: fillCart,
    refresh: function () {
      document.querySelectorAll('[data-iwa-delivery]').forEach(function (card) {
        if (card._iwaData && card._iwaVariant != null) update(card, card._iwaVariant);
      });
    },
    promise: function (lines, cc, now) {
      var card = document.querySelector('[data-iwa-delivery]');
      var cfg = card && card._iwaData && card._iwaData.cfg;
      return cfg ? promise(cfg, lines, cc, now) : null;
    },
    _promiseWith: promise,
    _v0: V0
  };

  function start() {
    initAll();
    scheduleSync();
    fillCart();
    watchCart();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
